import axios from 'axios';

const authUrl = import.meta.env.VITE_APP_BASE_URL; // AUTH API
const appUrl = import.meta.env.VITE_APP_API_URL; // NODE API
const adminAuthUrl = import.meta.env.VITE_ADMIN_APP_BASE_URL; // ADMIN AUTH API
const getToken = () => localStorage.getItem('Authorization');
const getRefreshToken = () => localStorage.getItem('RefreshToken');

const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('Authorization', accessToken);
  if (refreshToken) {
    localStorage.setItem('RefreshToken', refreshToken);
  }
};

export const clearTokens = () => {
  localStorage.removeItem('Authorization');
  localStorage.removeItem('RefreshToken');
};

export const authAxios = axios.create({
  baseURL: authUrl,
  timeout: 300000,
  withCredentials: true,
});

export const adminAuthAxios = axios.create({
  baseURL: adminAuthUrl,
  timeout: 300000,
  withCredentials: true,
});

export const appAxios = axios.create({
  baseURL: appUrl,
  timeout: 300000,
  withCredentials: true,
});

authAxios.interceptors.request.use(config => config);
appAxios.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRefreshing = false;
let refreshPromise = null;

appAxios.interceptors.response.use(
  response => {
    const permitChatId = response.data?.migration?.permitChatId;
    if (permitChatId) {
      window.location.href = `/citypermit/project/chat/${permitChatId}?showauthmodal=true&showstepper=true`;
    }
    return response;
  },
  async error => {
    const status = error.response?.status;
    if (status === 429) {
      clearTokens();
      window.location.href = '/auth?limit_exceeded=true';
      return Promise.reject(error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const applicationName = error.response.data.application;

      if (!isRefreshing) {
        isRefreshing = true;

        const refreshToken = getRefreshToken();
        if (!refreshToken) {
          clearTokens();
          window.location.href = '/auth';
          return Promise.reject(error);
        }

        let refreshTokenaxiosInstance = (applicationName == "AdminAuth") ? adminAuthAxios : authAxios;
        refreshPromise = refreshTokenaxiosInstance
          .get('/Auth/v1.0/refresh-token', {
            headers: { Authorization: `Bearer ${refreshToken}` },
          })
          .then(res => {
            const { accessToken, refreshToken: newRefresh } = res.data.data;
            setTokens(accessToken, newRefresh);
            return accessToken;
          })
          .catch(err => {
            clearTokens();
            if (applicationName === "AdminAuth") {
              window.location.href = '/admin/auth';
            } else {
              window.location.href = '/auth';
            }
            throw err;
          })
          .finally(() => {
            isRefreshing = false;
            refreshPromise = null;
          });
      }

      try {
        const newToken = await refreshPromise;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return appAxios(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);